import { render, staticRenderFns } from "./FeedbackAnswers.vue?vue&type=template&id=cd24314a&scoped=true"
import script from "./FeedbackAnswers.vue?vue&type=script&lang=js"
export * from "./FeedbackAnswers.vue?vue&type=script&lang=js"
import style0 from "./FeedbackAnswers.vue?vue&type=style&index=0&id=cd24314a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd24314a",
  null
  
)

export default component.exports